// extracted by mini-css-extract-plugin
export default {"container":"UZ-z","list":"VZ-z"};